/**
 * Created by Administrador on 10/21/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('rules', {
                parent: 'app',
                url: '/rules?page&size',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                params: {
                    page: "0",
                    size: "100"
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/rule/rules.html',
                        controller: 'rulesController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['rule']);
                    }],
                    rules: ['ruleService', '$stateParams', function (ruleService, $stateParams) {
                        return ruleService.getRules($stateParams.page, $stateParams.size)
                    }]
                }
            })
            .state('ruleNew', {
                parent: 'app',
                url: '/rule/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/rule/newEditRule.html',
                        controller: 'newEditRuleController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['rule', 'passengerType', 'operation']);
                    }],
                    rule: [function(){
                        return null;
                    }],
                    ruleId: [function(){
                        return 0;
                    }]
                }
            })
            .state('ruleEdit', {
                parent: 'app',
                url: '/rule/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/rule/newEditRule.html',
                        controller: 'newEditRuleController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['rule', 'passengerType', 'operation']);
                    }],
                    rule: ['ruleService', '$stateParams', function(ruleService, $stateParams){
                        return ruleService.getRule($stateParams.id);
                    }],
                    ruleId: ['$stateParams', function($stateParams){
                        return $stateParams.id;
                    }]
                }
            })
            .state('ruleDelete', {
                parent: 'rules',
                url: '/rule/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/rates/rule/deleteRule.html',
                        controller: 'deleteRuleController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            'ruleId': [function() {
                                return $stateParams.id
                            }],
                            'rule': ['ruleService', function(ruleService) {
                                return ruleService.getRule($stateParams.id)
                            }]
                        }
                    }).result.then(function() {
                        $state.go('rules', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();
